import { IMarketAward } from 'src/domain/caiso/cmri/interface';

export enum marketAwardsModal {
    DENY = 'deny',
    APPROVE = 'approve',
    VIEW = 'view',
    AUDIT = 'audit',
}

export interface ModalState {
    modal?: marketAwardsModal;
    targets: IMarketAward[];
}

interface DenyAction {
    type: 'DENY';
    payload: IMarketAward[];
}

interface ApproveAction {
    type: 'APPROVE';
    payload: IMarketAward[];
}

interface ViewAction {
    type: 'VIEW';
    payload: IMarketAward;
}

interface AuditAction {
    type: 'AUDIT';
    payload: IMarketAward;
}

interface CloseAction {
    type: 'CLOSE';
}

type ModalStateAction = DenyAction | ApproveAction | ViewAction | AuditAction | CloseAction;

export function reducer(state: ModalState, action: ModalStateAction): ModalState {
    switch (action.type) {
        case 'DENY':
            return {
                modal: marketAwardsModal.DENY,
                targets: [...action.payload],
            };
        case 'APPROVE':
            return {
                modal: marketAwardsModal.APPROVE,
                targets: [...action.payload],
            };
        case 'VIEW':
            return {
                modal: marketAwardsModal.VIEW,
                targets: [action.payload],
            };
        case 'AUDIT':
            return {
                modal: marketAwardsModal.AUDIT,
                targets: [action.payload],
            };
        case 'CLOSE':
            return {
                modal: undefined,
                targets: [],
            };
        default:
            return state;
    }
}
